import styled from '@emotion/styled'

export const Items = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2rem;
  max-width: 1440px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`
